import React, { useEffect, useRef, useState } from "react";
import { Toast } from "../../Component/Toast";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import RawWebSocket from "../../Websocker/RawWebSocket";

const storage = {
  getString: (k) => localStorage.getItem(k),
  set: (k, v) => localStorage.setItem(k, v),
};

// Fallback limits keyed by digit_fee — used only when maximum_quantity is 0
const PRICE_LIMITS_FALLBACK = {
  6: 30,
  12: 30,
  22: 20,
  28: 15,
  30: 15,
  55: 10,
  60: 10,
  20: 10,
  50: 4,
  100: 2,
};

const ThreeDigitScreen = ({
  threeData = [],
  lotName,
  lotTime,
  slotId,
  bookingClosedTime,
  userId,
}) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [cards, setCards] = useState([]);

  useEffect(() => {
    if (!threeData?.length) return;

    const needsRebuild =
      cards.length !== threeData.length ||
      threeData.some(
        (it, i) => (it.alpha?.length || 3) !== cards[i]?.digits?.length
      );

    if (needsRebuild) {
      setCards(
        threeData.map((it, i) => {
          const expectedLen = it.alpha?.length || 3;
          const existing = cards[i];
          return existing?.digits?.length === expectedLen
            ? existing
            : { digits: Array(expectedLen).fill(""), amount: "1" };
        })
      );
    }
  }, [threeData]);

  const digitRefs = useRef([]);
  const amountRefs = useRef([]);

  // Resolve max quantity per card: API value if > 0, else fallback by digit_fee
  const getMaxQty = (cardIndex) => {
    const item = threeData[cardIndex];
    if (!item) return Infinity;
    if (item.maximum_quantity > 0) return item.maximum_quantity;
    return PRICE_LIMITS_FALLBACK[item.digit_fee] ?? Infinity;
  };

  const increaseAmount = (cardIndex) => {
    const limit = getMaxQty(cardIndex);
    setCards((prev) => {
      const copy = prev.map((c) => ({ ...c, digits: [...c.digits] }));
      const cur = parseInt(copy[cardIndex].amount || "0", 10);
      const nextVal = Math.min(limit, cur + 1);
      copy[cardIndex].amount = String(nextVal);
      return copy;
    });
  };

  const decreaseAmount = (cardIndex) => {
    setCards((prev) => {
      const copy = prev.map((c) => ({ ...c, digits: [...c.digits] }));
      const cur = parseInt(copy[cardIndex].amount || "0", 10);
      copy[cardIndex].amount = String(Math.max(0, cur - 1));
      return copy;
    });
  };

  const handleDigitChange = (cardIndex, digitIndex, rawText) => {
    const text = rawText.replace(/[^0-9]/g, "").slice(0, 1);
    setCards((prev) => {
      const copy = prev.map((c) => ({ ...c, digits: [...c.digits] }));
      copy[cardIndex].digits[digitIndex] = text;
      return copy;
    });

    if (text.length === 1) {
      const len =
        threeData[cardIndex]?.alpha?.length ||
        cards[cardIndex]?.digits.length ||
        3;
      if (digitIndex < len - 1) {
        setTimeout(() => {
          digitRefs.current[cardIndex]?.[digitIndex + 1]?.focus?.();
        }, 50);
      } else {
        setTimeout(() => {
          amountRefs.current[cardIndex]?.focus?.();
        }, 50);
      }
    }
  };

  const handleAmountChange = (cardIndex, rawText) => {
    const limit = getMaxQty(cardIndex);
    const numeric = rawText.replace(/[^0-9]/g, "");
    if (numeric === "") {
      setCards((prev) => {
        const copy = prev.map((c) => ({ ...c, digits: [...c.digits] }));
        copy[cardIndex].amount = "";
        return copy;
      });
      return;
    }
    const num = parseInt(numeric, 10);
    const finalVal = Math.min(limit, num);
    setCards((prev) => {
      const copy = prev.map((c) => ({ ...c, digits: [...c.digits] }));
      copy[cardIndex].amount = String(finalVal);
      return copy;
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const handler = () => {
      setIsOpen(viewport.height < window.innerHeight);
    };
    viewport.addEventListener("resize", handler);
    return () => viewport.removeEventListener("resize", handler);
  }, []);

  const handleAdd = async (cardIndex) => {
    const card = cards[cardIndex];
    console.log("cardIndex:", cardIndex);
    console.log("cards length:", cards.length);
    console.log("threeData length:", threeData.length);
    console.log("card:", cards[cardIndex]);
    if (card.digits.some((d) => d === "")) {
      Toast("Please enter all digits");
      return;
    }
    const amount = parseInt(card.amount || "0", 10);
    if (amount <= 0) {
      Toast("Please enter a valid Count");
      return;
    }

    const addedValue = {
      ticket_amount: threeData[cardIndex].digit_fee * amount,
      price: threeData[cardIndex].digit_fee,
      lot_details:
        `${threeData[cardIndex].fee_price_name} ${threeData[cardIndex].alpha.join("")} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),

      my_number: card.digits.join(""),
      count: amount,
      client_id: userId,
      fee_price_id: threeData[cardIndex]?.fee_price_id,
      game_slot_id: slotId || null,
      type: threeData[cardIndex]?.type,
      digit: threeData[cardIndex].alpha.join(""),
      name: `${threeData[cardIndex].fee_price_name} ${threeData[cardIndex].alpha.join("")} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),
    };

    let payload = {
      user_id: userId,
      cart_item: [addedValue],
    };
    console.log("add via socket:", payload);
    RawWebSocket.emit("cart_add", payload);

    setCards((prev) => {
      const copy = [...prev];
      copy[cardIndex] = {
        digits: Array(card.digits.length).fill(""),
        amount: "1",
      };
      return copy;
    });
    if (isKeyboardOpen && isOpen) {
      digitRefs.current[cardIndex]?.[0]?.focus?.();
    }
  };

  const handleBox = async (cardIndex) => {
    const card = cards[cardIndex];
    if (card.digits.some((d) => d === "")) {
      Toast("Please enter all digits");
      return;
    }
    const amount = parseInt(card.amount || "0", 10);
    if (amount <= 0) {
      Toast("Please enter a valid count");
      return;
    }

    const digits = card.digits;
    const permutations = [];
    const dfs = (path, used) => {
      if (path.length === digits.length) {
        permutations.push(path.join(""));
        return;
      }
      for (let i = 0; i < digits.length; i++) {
        if (!used[i]) {
          used[i] = true;
          dfs([...path, digits[i]], used);
          used[i] = false;
        }
      }
    };
    dfs([], Array(digits.length).fill(false));

    const uniqueValues = [...new Set(permutations)];

    const result = uniqueValues.map((perm) => ({
      ticket_amount: threeData[cardIndex].digit_fee * amount,
      price: threeData[cardIndex].digit_fee,
      lot_details:
        `${threeData[cardIndex].fee_price_name} ${threeData[cardIndex].alpha.join("")} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),

      my_number: perm,
      count: amount,
      client_id: userId,
      fee_price_id: threeData[cardIndex]?.fee_price_id,
      game_slot_id: slotId || null,
      type: threeData[cardIndex]?.type,
      digit: threeData[cardIndex].alpha.join(""),
      name: `${threeData[cardIndex].fee_price_name} ${threeData[cardIndex].alpha.join("")} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),
    }));

    let payload = {
      user_id: userId,
      cart_item: result,
    };
    console.log("add via socket", payload);
    RawWebSocket.emit("cart_add", payload);

    setCards((prev) => {
      const copy = [...prev];
      copy[cardIndex] = {
        digits: Array(card.digits.length).fill(""),
        amount: "1",
      };
      return copy;
    });
    if (isKeyboardOpen && isOpen) {
      digitRefs.current[cardIndex]?.[0]?.focus?.();
    }
  };

  const handleRandom = (cardIndex) => {
    setIsKeyboardOpen(false);
    setCards((prev) => {
      const copy = prev.map((c) => ({ ...c, digits: [...c.digits] }));
      const len = copy[cardIndex].digits.length;
      for (let i = 0; i < len; i++)
        copy[cardIndex].digits[i] = String(Math.floor(Math.random() * 10));
      return copy;
    });
  };

  if (!cards.length) return null;

  return (
    <div className="three-container">
      {threeData.map((it, cardIndex) => (
        <div className="cardss" key={cardIndex}>
          <div className="sd-card-header">
            <div>
              <div className="sd-row">
                <div className="sd-card-title">{`${it?.fee_price_name?.replace(/[0-9]/g, "") || ""}${it?.fee_price_name ? " Win" : ""}`}</div>
                <div className="sd-price">{`₹${it?.price || ""}`}</div>
              </div>
              <div className="sd-row">
                <div className="sd-small">Buy price</div>
                <div className="sd-price">{`₹${it?.digit_fee || ""}`}</div>
              </div>
            </div>
            <div className="sd-random" onClick={() => handleRandom(cardIndex)}>
              Random
            </div>
          </div>

          <div className="input-row">
            <div className="digits-row">
              {it.alpha?.map((label, labelIndex) => {
                if (!digitRefs.current[cardIndex])
                  digitRefs.current[cardIndex] = [];
                return (
                  <div
                    className="digit-group"
                    key={`${cardIndex}-${labelIndex}`}
                  >
                    <div className="sd-ab">{label}</div>
                    <input
                      ref={(el) =>
                        (digitRefs.current[cardIndex][labelIndex] = el)
                      }
                      className="sd-digit"
                      inputMode="numeric"
                      onFocus={() => setIsKeyboardOpen(true)}
                      maxLength={1}
                      value={cards[cardIndex]?.digits?.[labelIndex] ?? ""}
                      onChange={(e) =>
                        handleDigitChange(cardIndex, labelIndex, e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (
                          e.key === "Backspace" &&
                          (cards[cardIndex]?.digits?.[labelIndex] ?? "") === ""
                        ) {
                          if (labelIndex > 0)
                            digitRefs.current[cardIndex]?.[
                              labelIndex - 1
                            ]?.focus?.();
                        }
                      }}
                    />
                  </div>
                );
              })}
            </div>

            <div className="controls-column">
              <div className="sd-counter">
                <button type="button" onClick={() => decreaseAmount(cardIndex)}>
                  -
                </button>
                <input
                  ref={(el) => (amountRefs.current[cardIndex] = el)}
                  inputMode="numeric"
                  maxLength={3}
                  value={cards[cardIndex]?.amount ?? ""}
                  onChange={(e) =>
                    handleAmountChange(cardIndex, e.target.value)
                  }
                  onFocus={(e) => {
                    setIsKeyboardOpen(true);
                    e.target.select();
                  }}
                  onKeyDown={(e) => {
                    if (
                      e.key === "Backspace" &&
                      (cards[cardIndex]?.amount ?? "") === ""
                    ) {
                      const lastIndex = (it.alpha?.length || 1) - 1;
                      digitRefs.current[cardIndex]?.[lastIndex]?.focus?.();
                    }
                  }}
                />
                <button onClick={() => increaseAmount(cardIndex)}>+</button>
              </div>

              <div className="add-row">
                {it.alpha?.length === 3 ? (
                  <>
                    <button
                      className="sd-add-box"
                      onClick={() => handleBox(cardIndex)}
                    >
                      Box
                    </button>
                    <button
                      className="sd-add"
                      onClick={() => handleAdd(cardIndex)}
                    >
                      ADD
                    </button>
                  </>
                ) : (
                  <button
                    className="add-btn-single sd-add full"
                    onClick={() => handleAdd(cardIndex)}
                  >
                    ADD
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ThreeDigitScreen;